var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingView),expression:"loadingView"}]}),(!_vm.loadingView)?_c('div',[_c('router-view',{attrs:{"brands":_vm.brands,"steps":_vm.steps,"structure":_vm.structure}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }